export default __webpack_public_path__ + "static/media/comunicazione.19485310.jpg";